import { Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const CalloutBox = styled.div`
  background-color: ${({ theme }) => theme.colors.grey10};
  margin: 1rem 0;
  padding: 1rem;
`;

export const SectionContainer = styled(Section)`
  position: relative;
  z-index: 1;
`;

export const ContentContainer = styled.div`
  margin-top: 0;
`;

export const MiddlePart = styled(Section)`
  padding: 6rem 0 0;
`;

export const LastPart = styled(Section)`
  padding: 6rem 0 0.75rem;
`;
